"use client";
import useTranslation from "@/hook/useTranslation";
import { Button } from "../../Button";
import FastBullChart from "../../FastBullChart";
import { IoIosLogIn } from "react-icons/io";

const TradeLayout = () => {
  const { t } = useTranslation();
  return (
    <div className="trade-layout">
      <div className="price-title">{t("marketChart")}</div>
      <div className="trade-content">
        <div className="trade-chart">
          <FastBullChart />
          <Button
            type="light"
            className="trade-button"
            onClick={() => {
              window.open("https://www.fastbull.com/traders/chart", "_blank");
            }}
          >
            <IoIosLogIn size={22} style={{ marginRight: 8 }} />
            {t("Explore")}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default TradeLayout;
